import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { deleteHwRate, fetchHwRates, reloadHwRate } from '../../../../../api/hostelWorldApi/hwRates'
import { selectCurrentOrganization } from '../../../../../selectors/hostelworldSelectors/hwCurrentOrganization'
import { selectEasymsRatesKV } from '../../../../../selectors/hostelworldSelectors/hwEasymsSelector'
import { selectRates, selectRatesFetching } from '../../../../../selectors/hostelworldSelectors/hwRates'
import RatesTable from './RatesTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 300
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class RatesTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        rates: PropTypes.array.isRequired,
        easymsRatesKV: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchHwRates: PropTypes.func.isRequired,
        reloadHwRate: PropTypes.func.isRequired,
        deleteHwRate: PropTypes.func.isRequired
    }

    state = {
        ourId: ''
    }

    componentDidMount() {
        const params = { organizationId: this.props.currentOrganization }
        this.props.fetchHwRates(params)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentOrganization !== this.props.currentOrganization) {
            const params = { organizationId: this.props.currentOrganization }
            this.props.fetchHwRates(params)
            this.setState({ ourId: '' })
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleClick = () => {
        const { ourId } = this.state
        this.props.reloadHwRate({
            organizationId: this.props.currentOrganization,
            ourId
        })
        this.setState({
            ourId: ''
        })
    }

    handleDelete = ourId => {
        this.props.deleteHwRate(ourId)
    }

    handleReimport = remoteId => {
        const { rates } = this.props
        const item = rates.find(i => i.remoteId === remoteId)

        this.props.reloadHwRate({
            organizationId: this.props.currentOrganization,
            ourRateId: item.ourId
        })
    }

    render() {
        const { classes, fetching, rates, easymsRatesKV } = this.props
        const { ourId } = this.state

        const valid = !!ourId

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TextField
                        select
                        label="Тариф EasyMS"
                        className={classes.formControl}
                        value={ourId}
                        onChange={this.handleSelect('ourId')}
                    >
                        {easymsRatesKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Импортировать тарифы с HostelWorld.com
                    </Button>

                    <Typography variant="caption" color="error">
                        <strong>P. S. Не импотируйте те тарифы, которые уже есть в таблице. Иначе будет ошибка!</strong>
                    </Typography>
                </Paper>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <RatesTable rates={rates} onDelete={this.handleDelete} onReimport={this.handleReimport} />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        rates: selectRates(state),
        fetching: selectRatesFetching(state),
        easymsRatesKV: selectEasymsRatesKV(state),
        currentOrganization: selectCurrentOrganization(state)
    }),
    { fetchHwRates, reloadHwRate, deleteHwRate }
)(withStyles(styles)(RatesTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/RatesTab/RatesTab.js